// extracted by mini-css-extract-plugin
export default {"vote":"index_vote_sLk0w","voted":"index_voted_bPCDa"};